import "./styles/Footer.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faWhatsapp
} from "@fortawesome/free-brands-svg-icons";

function Footer() {
    return (
        <div className="footer-container">
            <div className="footer-socials">
                <a href="https://www.facebook.com/Fanttech/"
                    className="facebook social">
                    <FontAwesomeIcon icon={faFacebook} size="2x" />
                </a>
                <a href="https://www.instagram.com/fanttecheng"
                    className="instagram social">
                    <FontAwesomeIcon icon={faInstagram} size="2x" />
                </a>
                <a href="https://wa.me/5555984159899?text=Ola%20Eu%20venho%20atraves%20do%20site"
                    className="whatsapp social">
                    <FontAwesomeIcon icon={faWhatsapp} size="2x" />
                </a>
            </div>
            <span>Rua Fernando Ferrari, 222. Santa Rosa / RS. CEP 98780-768</span>
            <span>Todos os direitos reservados.</span>
        </div>
    )
}

export default Footer
